module.exports = __webpack_public_path__ + "static/media/logo.df133739.png";